<template>
  <div class="part" v-infinite-scroll="load"  infinite-scroll-immediate>
    <el-row class="container" :gutter="8">
      <el-col :span="5">
        <div class="" style="option:0;height:10px"></div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content dynamics-content" style="background-color:rgba(0,0,0,0);"  >
          <div
            class="dynamics"
            v-for="(item,index) in dynamic"
            :key="index"
          >
            <el-avatar class="avatar" :size="48" :src="item.creatorUser.avatarUrl || defImg"></el-avatar>
            <div class="title">
              <h3 v-text="item.creatorUser.name"></h3>
              <!-- <h5 v-text="'联系方式' + item.phoneNumber"></h5> -->
            </div>
            <div class="content">
              <p v-text="item.content"></p>
              <div v-if="item.articleFiles != []">
                <ul class="imgbox" v-if="isImg(item.articleFiles[0].filePath)">
                
              </ul>
              <ul class="videoBox" v-else>
                <li v-for="(item1,index1) in item.articleFiles" :key="index1">
                  <VideoPlay :src="item1.filePath"></VideoPlay>
                </li>
              </ul>
              </div>
              
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="7">
        <!-- <div class="grid-content" style="option:0;">2</div> -->
      </el-col>
    </el-row>
  </div>

  <!-- <div v-for="(item,index) in dynamic" :key="index">
            <img :src="item.creatorUser.avatarUrl || defImg" alt="" width="132px">
            <p>{{item.creatorUser.name}}</p>
            <p>{{item.content}}</p>
            <p>联系电话:{{item.phoneNumber}}</p>
            <div v-if="!!item.articleFiles">
                <div v-for="(item1,index1) in item.articleFiles" :key="index1">   
                    <div v-if="isImg(item1.filePath)">
                        <img :src="item1.filePath" alt="">
                    </div>
                    <div v-else>
                        <video :src="item1.filePath" controls></video>
                    </div>
                </div>
            </div>
            <p>{{item.creationTime}}</p>
        </div>

  </div>-->
</template>

<script>
import VideoPlay from "@/components/VideoPlay/VideoPlay";

export default {
  name: "Dynamic",
  components: {
    VideoPlay
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      dynamic: [],
      count: 0,
      defImg: require("@/assets/images/0.png"),
      loading: false
    };
  },
  computed: {
    noMore() {
      return this.pageSize >= 10;
    },
    disabled () {
        return this.loading || this.noMore
    }
  },
  methods: {
    getDynamic() {
      this.$http
        .get("/v1/api/services/moments/MomentsArticle/GetPageResult", {
          params: {
            page: this.currentPage,
            limit: this.pageSize,
            where: "",
            keyword: ""
          }
        })
        .then(res => {
          this.dynamic = res.data;
        });
    },
    isImg(e) {
      let index = e.lastIndexOf(".");
      let type = e.substring(index + 1, e.length);
      if (type == "jpg" || type == "jpeg" || type == "png" || type == "gif") {
        return true;
      } else {
        return false;
      }
    },
    getimgArr(e) {
      let imgArr = e.map(item => {
        if (!!item.filePath){
          if (this.isImg(item.filePath)) {
          return item.thumb300Path;
        }
        }
        
      });
      return imgArr;
    },
    load() {
        console.log(this.pageSize)
        this.loading = true
        setTimeout(() => {
          
          this.pageSize += 2
          this.loading = false
        }, 2000)
      }
  },
  created() {
 this.getDynamic();
  }
};
</script>

<style scoped>
.part {
  background: #f1f2f7;
  padding-top: 8px;
}
.container {
  margin: 0 auto !important;
}
.part >>> .el-col .grid-content {
  background: white;
  border-radius: 4px;
}
.dynamics {
  padding-top: 27px;
  padding-left: 98px;
  position: relative;
  min-height: 88px;
  background-color: white;
  border-radius: 4px;
  margin-bottom: 8px;
  padding-right: 4px;
  padding-bottom: 8px;
}
.avatar {
  position: absolute;
  top: 24px;
  left: 24px;
}
.title h3 {
  font-size: 16px;
  font-weight: normal;
}
.title h5 {
  color: #99a2aa;
  padding-top: 4px;
  font-size: 12px;
  font-weight: normal;
}
.content {
  margin-top: 10px;
  display: block;
  color: inherit;
  padding-right: 10px;
}
.content p {
  font-size: 14px;
  line-height: 22px;
  word-wrap: break-word;
  letter-spacing: 0.5px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  word-wrap: break-word;
  margin-bottom: 10px;
}
.imgbox {
  width: 456px;
}
.imgbox >>> .el-image {
  height: 100%;
  width: 100%;
}
.imgbox li {
  width: 144px;
  height: 144px;
  margin: 4px 0 0 4px;
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
  border-radius: 4px;
  position: relative;
  cursor: -webkit-zoom-in;
  cursor: zoom-in;
}
.video-player {
  border-radius: 4px;
  overflow: hidden;
}
</style>